/*
 * View for the examples section of the topic page
 */

define([
  "marionette",
  "jquery",
  "modules/topicsSplit/topic/topicExamples/template/topicExamplesTemplate.html",
  "modules/topicsSplit/topic/topicExamples/template/topicExamplesItemTemplate.html",
  "i18n/i18n",
  "jquery-ui",
  "jquery-ui/ui/widgets/droppable",
], function (Marionette, $, TopicExamplesTemplate, TopicExamplesItemTemplate) {
  "use strict";

  const TopicExamplesView = {};

  TopicExamplesView.topicExampleView = Marionette.ItemView.extend({
    template: TopicExamplesItemTemplate,
    tagName: "tr",
    onRender: function () {
      //internationalize the html
      this.$el.i18n();
      //apply tooltips
      this.$el
        .find(
          'a[data-toggle="tooltip"], button[data-toggle="tooltip"], span[data-toggle="tooltip"]',
        )
        .tooltip({ delay: { show: 333, hide: 0 }, container: "body" });
    },
    triggers: {
      "click #example": "edit:example",
      "click #exampleDelete": "delete:example",
    },
  });

  // noinspection JSUnusedGlobalSymbols
  TopicExamplesView.topicExamplesView = Marionette.CompositeView.extend({
    template: TopicExamplesTemplate,
    itemView: TopicExamplesView.topicExampleView,
    itemViewContainer: "#exampleList",
    collectionEvents: {
      sort: "_renderChildren",
    },
    emptyError: function (errorMessage) {
      this.$el
        .find("#exampleError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    getLocaleId: function () {
      return this.$el.find("#exampleLocales").val();
    },
    setSelectedLocale: function (localeId) {
      this.$el.find("#exampleLocales").val(localeId);
    },
    onAfterItemAdded: function (itemView) {
      //remove delete button if there is only one entry
      if (this.collection.size() === 1) {
        itemView.$el.find("#exampleDelete").html("");
      }
    },
    onItemRemoved: function () {
      //remove delete button if there's now only one view (entry)
      if (this.children.length === 1) {
        this.children.first().$el.find("#exampleDelete").html("");
      }
    },
    onRender: function () {
      this.$el.i18n();
      this.$el
        .find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]')
        .tooltip({ delay: { show: 333, hide: 0 }, container: "body" });
      if (this.collection.allowEditExamples) {
        const _this = this;
        //support for dropping learner examples into the example area
        this.$el.find(".example-list").droppable({
          addClasses: false,
          activeClass: "droppable-active",
          hoverClass: "droppable-hover",
          tolerance: "pointer",
          drop: function () {
            _this.trigger("dropped:example");
          },
        });
      }
    },
    triggers: {
      "click #addExample": "add:example",
      "change #exampleLocales": "change:locale",
      "click #generateExamples": "generate:examples",
    },
  });

  return TopicExamplesView;
});
